import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const ticketCreate = payload => AxiosClient.post('/ticket', payload);
const getTicketList = (params) => AxiosClient.get('/ticket', params);
const showTicket = (id, query) => AxiosClient.get(`/ticket/${id}`, {...query});
const updateTicketStatus = (params, payload) => AxiosClient.put(`/ticket/${params.ticketId}/status/${params.statusId}`, { ...payload });
const updateTicket = (ticketId, payload) => AxiosClient.put(`/ticket/${ticketId}`, { ...payload });
const deleteTicket = (ticketId, payload) => AxiosClient.delete(`/ticket/${ticketId}`, { data: payload });

export {
    ticketCreate,
    getTicketList,
    showTicket,
    updateTicketStatus,
    updateTicket,
    deleteTicket
}